import _objectSpread from "@babel/runtime-corejs2/helpers/objectSpread2";
import _parseInt from "@babel/runtime-corejs2/core-js/parse-int";
import _Object$keys from "@babel/runtime-corejs2/core-js/object/keys";
import escape from 'lodash/escape';
import * as React from 'react';
import ReactDOM from 'react-dom/server';
import snarkdown from '@bpmn-io/snarkdown';
import Counterpart from 'counterpart';
import { escapeMarkdown } from '../react/utils/escapeMarkdown';
var componentToString = function componentToString(key, elt) {
  if (! /*#__PURE__*/React.isValidElement(elt) && !Array.isArray(elt)) return elt;
  try {
    return ReactDOM.renderToStaticMarkup(elt);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn("In @gandi/translate, unable to render component ".concat(key), err);
    return elt;
  }
};

/**
 * Wrap Counterpart translate function for more features.
 */
var enhanceTranslate = function enhanceTranslate(namespace, translate, sanitize, logger) {
  return function (message) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var defaultOptions = {
      withHTML: false,
      withMarkdown: false,
      escapeParameters: false,
      scope: namespace,
      fallback: message
    };
    var parsedOptions = _objectSpread(_objectSpread({}, defaultOptions), options);

    // ensure that count is a digit
    if ('count' in parsedOptions) {
      parsedOptions.count = _parseInt(parsedOptions.count, 10) || 0;
    }
    if (parsedOptions.withMarkdown) {
      parsedOptions.withHTML = true;
    }

    // Resolve React components to static markup if needed
    parsedOptions = _Object$keys(parsedOptions).reduce(function (acc, key) {
      // $FlowFixMe[incompatible-type]
      acc[key] = componentToString(key, parsedOptions[key]);
      return acc;
    }, {});

    // Due to legacy, `withHTML` implicitly turns on parameter escaping.
    if (parsedOptions.withHTML && !('escapeParameters' in options)) {
      parsedOptions.escapeParameters = true;
    }
    if (parsedOptions.escapeParameters === true) {
      parsedOptions = _Object$keys(parsedOptions).reduce(function (acc, key) {
        var value = parsedOptions[key];
        if (typeof value === 'string' && ['scope', 'fallback'].indexOf(key) === -1) {
          if (parsedOptions.withMarkdown) {
            // Don't transform translation variables
            // into markdown by default
            // https://github.com/bpmn-io/snarkdown/pull/5/files
            value = escapeMarkdown(value);
          }
          value = escape(value);
        }

        // $FlowFixMe[incompatible-type]
        acc[key] = value;
        return acc;
      }, {});
    }
    if (parsedOptions.withHTML) {
      var html;
      var translatedMessage = '';

      // Use native translate.onError() instead
      try {
        translatedMessage = translate(message, parsedOptions);
      } catch (err) {
        logger.error({
          err: err
        }, "Error during the translation of the message \"".concat(message, "\". ") + 'Check that all arguments are defined.');
      }

      // Convert Markdown to HTML
      if (parsedOptions.withMarkdown) {
        html = snarkdown(translatedMessage).replace(/\n/g, '');
      } else {
        // Just save HTML if withMarkdown is false
        html = translatedMessage;
      }

      // Wrap for dangerouslySetInnerHTML property
      // $FlowFixMe[incompatible-return]
      return {
        __html: html
      };
    }

    // Use native translate.onError() instead
    try {
      var _translatedMessage = translate(message, parsedOptions);
      return typeof sanitize === 'function' ?
      // $FlowFixMe[incompatible-return]
      sanitize(_translatedMessage) :
      // $FlowFixMe[incompatible-return]
      _translatedMessage;
    } catch (err) {
      logger.error({
        err: err
      }, "Error during the translation of the message \"".concat(message, "\". ") + 'Check that all arguments are defined.');

      // $FlowFixMe[incompatible-return]
      return '';
    }
  };
};
export default enhanceTranslate;